<template>
  <div class="row">
    <div class="col text-right">
      <Button label="Fermer" @click="fermer"/>
    </div>
  </div>
  <div v-if="isRechercheDataLoading == true" class="row">
    <div class="col">
      <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
    </div>
  </div>
  <div v-else class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="dossiers"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          selectionMode="single"
          :paginator="true"
          :rows="100"
          paginatorPosition="bottom"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} à {last} sur {totalRecords} dossiers"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <div >
          <Column headerStyle="width: 3rem" :exportable="false">
            <template #body="slotProps">
              <div>
                <Button
                    icon="pi pi-arrow-circle-up"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="republier(slotProps.data)"
                    :disabled="disableRemove"
                    v-show="slotProps.data.statutPublication === 'error'"
                />
              </div>
            </template>
          </Column>
        </div>
        <Column
            field="numeroCP"
            header="Numéro Client"
            :sortable="true"
        ></Column>
        <Column
            field="statutPublication"
            header="Statut Pub"
            :sortable="true"
        ></Column>
        <Column field="datePublication" header="Date Pub" :sortable="true">
          <template #body="slotProps">
            {{ $commun.formatDateHeure(slotProps.data.datePublication) }}
          </template>
        </Column>
        <Column field="dateConsommation" header="Date Cons" :sortable="true">
          <template #body="slotProps">
            {{ $commun.formatDateHeure(slotProps.data.dateConsommation) }}
          </template>
        </Column>
        <Column
            field="numeroFicheSujet"
            header="Fiche Sujet"
            :sortable="true"
        ></Column>
        <Column
            field="versionDonnees"
            header="Version donnée"
            :sortable="true"
        ></Column>
        <Column
            field="numeroDossier"
            header="Numéro Cardex"
            :sortable="true"
        ></Column>
        <Column
            field="cptErrPubPDD"
            header="Nbr de reprise Pub"
            :sortable="true"
        ></Column>
        <Column
            field="cptErrConsPDD"
            header="Nbr de reprise Cons"
            :sortable="true"
        ></Column>
        <Column
            field="contenuErreurPub"
            header="Contenue de l'erreur Pub"
            :sortable="true"
        ></Column>
        <Column
            field="contenuErreurCons"
            header="Contenue de l'erreur Cons"
            :sortable="true"
        ></Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  name: "DossiersErreur",
  data() {
    return {
        dossiers: [],
        isRechercheDataLoading: false,
        disableRemove: false
    };
  },
  beforeMount() {
    this.$root.$refs.breadcrumbComp.source.nom = 'dossierErreur';
  },       
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Dossier Erreur");

    this.isRechercheDataLoading = true;
    this.$store.dispatch('dossierClient/obtenirDossiersErreurAction').then((res) => {
      this.dossiers = res.data;
      this.isRechercheDataLoading = false;
    })
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    republier(dossier) {
      this.disableRemove = true
      this.$store.dispatch('dossierClient/republierDossierErreurAction', dossier).then((res) => {
        this.disableRemove = false
        if(res.data.severite == "success") {
          let index = this.dossiers.indexOf(dossier)
          if(index > -1) {
            this.dossiers.splice(index, 1)
          }
        }
        let messageList = []
        messageList.push(res.data)
        this.$root.$refs.messagesComp.messagesList = messageList;
      })
    }
  }
};
</script>

